import React, {useEffect, useState} from "react";
import {Grid, Typography} from "@mui/material";

import TextField from "@mui/material/TextField";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import './ContentDatePicker.scss';
import {DATE_FORMAT, FROM_DATE, TO_DATE} from "../../constants/constants";

export default function ContentDatePicker(props) {
    const DATE_PICKER_VIEWS = ['year', 'month', 'day'];
    const {fromDateHandler, toDateHandler} = props;
    const {fromDate, onValidFromDate, clearFromDate} = fromDateHandler;
    const {toDate, onValidToDate, clearToDate} = toDateHandler;
    const [fromValue, setFromValue] = useState(fromDate);
    const [toValue, setToValue] = useState(toDate);

    useEffect(() => {
        setFromValue(fromDate);
    }, [fromDate]);

    useEffect(() => {
        setToValue(toDate);
    }, [toDate]);

    function onFromDateAccept(value) {
        // Hitting the clear button
        if (value === null) {
            clearFromDate();
            clearToDate();
        }
    }

    function onToDateAccept(value) {
        // Hitting the clear button
        if (value === null) {
            clearToDate();
        }
    }

    function getFormattedDate(dateVal) {
        return moment(dateVal).format("YYYY-MM-DD");
    }

    useEffect(() => {
        if (fromValue !== null && !moment(fromValue).isValid()) {
            return;
        }
        if (toValue !== null && !moment(toValue).isValid()) {
            return;
        }

        moment.isMoment(fromValue) && onValidFromDate(getFormattedDate(fromValue));
        moment.isMoment(toValue) && onValidToDate(getFormattedDate(toValue));

    }, [fromValue, toValue, onValidFromDate, onValidToDate]);

    function renderDatePickerInput(params) {
        return <TextField
            {...params}
            className={'text-field-date'}
            size={'small'}
            onKeyDown={e => e.preventDefault()}
        />;
    }

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>

            <Grid container className="date-picker-container">
                <Grid item>
                    <DatePicker
                        className={'date-picker'}
                        componentsProps={{
                            actionBar: {
                                actions: ["clear"]
                            }
                        }}
                        inputFormat={DATE_FORMAT}
                        label={FROM_DATE}
                        maxDate={moment()}
                        onAccept={onFromDateAccept}
                        onChange={setFromValue}
                        renderInput={renderDatePickerInput}
                        value={fromValue}
                        views={DATE_PICKER_VIEWS}
                    />
                </Grid>
                <Grid item className={'grid-hyphen'}>
                    <Typography variant={'body1'}>&nbsp;-&nbsp;</Typography>
                </Grid>
                <Grid item>
                    <DatePicker
                        className={'date-picker'}
                        componentsProps={{
                            actionBar: {
                                actions: ["clear"]
                            }
                        }}
                        disabled={!!!fromValue}
                        inputFormat={DATE_FORMAT}
                        label={TO_DATE}
                        maxDate={moment()}
                        minDate={fromValue}
                        onAccept={onToDateAccept}
                        onChange={setToValue}
                        renderInput={renderDatePickerInput}
                        value={toValue}
                        views={DATE_PICKER_VIEWS}
                    />
                </Grid>
            </Grid>
        </LocalizationProvider>

    );
}
